import { createRouter, createWebHistory } from "vue-router";

import Confirm from "../views/pages/Confirm.vue";
import Extend from "../views/pages/Extend.vue";
import Invite from "../views/pages/Invite.vue";
import Login from "../views/pages/Login.vue";
import Nothing from "../views/pages/Nothing.vue";
import Objects from "../views/pages/Objects.vue";
import Profile from "../views/pages/Profile.vue";
import Recover from "../views/pages/Recover.vue";
import Register from "../views/pages/Register.vue";
import Reset from "../views/pages/Reset.vue";
import Set from "../views/pages/Set.vue";
import System from "../views/pages/System.vue";
import Systems from "../views/pages/Systems.vue";

const routes = [
	{
		path: "/",
		redirect: "/login",
	},
	{
		path: "/confirm",
		name: "confirm",
		component: Confirm,
	},
	{
		path: "/extend",
		name: "extend",
		component: Extend,
	},
	{
		path: "/invite",
		name: "invite",
		component: Invite,
	},
	{
		path: "/login",
		name: "login",
		component: Login,
	},
	{
		path: "/objects/:id",
		name: "objects",
		component: Objects,
	},
	{
		path: "/profile",
		name: "profile",
		component: Profile,
	},
	{
		path: "/recover",
		name: "recover",
		component: Recover,
	},
	{
		path: "/register",
		name: "register",
		component: Register,
	},
	{
		path: "/reset",
		name: "reset",
		component: Reset,
	},
	{
		path: "/set",
		name: "set",
		component: Set,
	},
	{
		path: "/system/:id",
		name: "system",
		component: System,
	},
	{
		path: "/systems",
		name: "systems",
		component: Systems,
	},
	{
		path: "/nothing",
		//path: "/:pathMatch(.*)",
		name: "nothing",
		component: Nothing,
	},
];

const router = createRouter({
	history: createWebHistory(),
	routes,
});

router.beforeEach(async (to) => {
	const loggedIn = localStorage.getItem("authorization__user-role");
	const publicPages = ["/login", "/nothing"];

	// 1. Публичные страницы (проверка по path)
	if (publicPages.includes(to.path)) return true;

	// 2. Редирект на логин
	if (!loggedIn) {
		localStorage.setItem("system__redirect", to.path);
		return { name: "login" };
	}

	// 3. Общие страницы для всех залогиненных
	if (to.path.startsWith("/profile")) return true;

	// 4. Определение доступов по ролям
	const isSystemRoute = ["/systems", "/system/"].some((p) => to.path.startsWith(p));
	const isObjectRoute = to.path.startsWith("/objects");

	if (loggedIn === "engineer" || loggedIn === "engineer_limited") {
		// И инженеру, и оператору можно в системы
		if (!isSystemRoute) return { name: "nothing" };
	} else if (loggedIn === "user") {
		// Юзеру можно только в объекты
		if (!isObjectRoute) return { name: "nothing" };
	} else {
		// Если роль неизвестна
		return { name: "nothing" };
	}

	return true;
});

export default router;
